module.exports = __webpack_public_path__ + "img/shipping-option.ec743b4a.svg";